/**
 * Webエミュレーション プラットフォームアダプタ (WebEmulatedBridgeAdapter)
 * ブラウザ開発環境や単体テスト向けのインメモリシミュレーションアダプタ
 */

import type { DisplayWorkArea, IPlatformBridgeAdapter, WindowBounds } from './IPlatformBridgeAdapter';

export class WebEmulatedBridgeAdapter implements IPlatformBridgeAdapter {
  private bounds: WindowBounds = {
    x: 100,
    y: 100,
    width: 320,
    height: 320,
  };
  private alwaysOnTop: boolean = false;
  private clickThrough: boolean = false;

  constructor(initialBounds?: Partial<WindowBounds>) {
    if (initialBounds) {
      this.bounds = { ...this.bounds, ...initialBounds };
    }
  }

  public isSupported(): boolean {
    return true;
  }

  public async setAlwaysOnTop(enable: boolean): Promise<void> {
    this.alwaysOnTop = enable;
  }

  public async setClickThrough(enable: boolean): Promise<void> {
    this.clickThrough = enable;
  }

  public async getBounds(): Promise<WindowBounds> {
    return { ...this.bounds };
  }

  public async setBounds(bounds: Partial<WindowBounds>): Promise<void> {
    this.bounds = { ...this.bounds, ...bounds };
  }

  public async getWorkArea(): Promise<DisplayWorkArea> {
    if (typeof window !== 'undefined' && window.screen) {
      return {
        x: 0,
        y: 0,
        width: window.screen.availWidth || 1920,
        height: window.screen.availHeight || 1080,
      };
    }
    return { x: 0, y: 0, width: 1920, height: 1080 };
  }

  // テスト検証用ゲッター
  public getIsAlwaysOnTop(): boolean {
    return this.alwaysOnTop;
  }

  public getIsClickThrough(): boolean {
    return this.clickThrough;
  }
}
